import { connect } from 'react-redux';
import { toggleBurgerMenuRequested } from '../../redux/actions';
import { getIsBurgerMenuOpen } from '../../redux/selectors';
var mapStateToProps = function (state) { return ({
    isBurgerMenuOpen: getIsBurgerMenuOpen(state),
}); };
var mapDispatchToProps = {
    toggleBurgerMenu: toggleBurgerMenuRequested,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=BurgerMenu.container.js.map